export default function isFeedbackFormValid(form: any, withFeedback: boolean): boolean {
  if (withFeedback) {
    return !!(form && form?.rating > 0 && form?.feedback && form?.comment);
  }
  return !!(form && form?.rating > 0 && form?.comment);
}
